import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const VEHICLE_RESOURCE = "vehicle" as const;
const VEHICLE_VALUATION_RESOURCE = "vehicle-valuation" as const;
export const VEHICLE_VALUATION_CONFIRM_API_PATH = `/v1/${VEHICLE_VALUATION_RESOURCE}/{uuid}/confirm` as const;

type GeneratedVehicleValuationConfirmBody =
  paths[typeof VEHICLE_VALUATION_CONFIRM_API_PATH]["patch"]["requestBody"]["content"]["application/json"];
type GeneratedVehicleValuationConfirmResponse =
  paths[typeof VEHICLE_VALUATION_CONFIRM_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export type VehicleValuationConfirmBody = GeneratedVehicleValuationConfirmBody & {
  confirmedVehiclePreparationCosts?: number;
};
export type VehicleValuationConfirmResponse = GeneratedVehicleValuationConfirmResponse & {
  confirmedVehiclePreparationCosts?: number | null;
  vehiclePreparationCosts: number;
};

export const useVehicleValuationConfirmMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<VehicleValuationConfirmResponse, Error, VehicleValuationConfirmBody & { uuid: string }>({
    mutationFn: async (body: VehicleValuationConfirmBody & { uuid: string }) => {
      const { uuid, ...rest } = body;
      const response = await alphartisApiAxios.patch<VehicleValuationConfirmResponse>(
        `/v1/${VEHICLE_VALUATION_RESOURCE}/${uuid}/confirm`,
        rest,
      );

      return response.data;
    },
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_VALUATION_RESOURCE],
        }),
        queryClient.invalidateQueries({
          queryKey: [VEHICLE_RESOURCE],
        }),
      ]);
    },
  });
};
